import { tv } from 'tailwind-variants'

export const itemDetailPopoverSubtitleVariants = tv({
  base: 'font-formula text-base font-bold',
  variants: {
    accentColor: {
      none: 'text-white',
      yellow: 'text-yellow',
      green: 'text-green',
      blue: 'text-blue'
    }
  },
  defaultVariants: {
    accentColor: 'none'
  }
})

export const arrowVariants = tv({
  base: '',
  variants: {
    hasFooter: {
      true: 'fill-[#434343]',
      false: 'fill-primary-background'
    }
  },
  defaultVariants: {
    hasFooter: false
  }
})